import { useParams, useRouteContext } from "@tanstack/react-router";

import { useLeaData } from "@/queries.ts";
import { childHeadingModel } from "./childHeadingModel";

export default function ChildIndividualHeading() {
  const leaContext = useRouteContext({ from: "/$leaid" });

  const params = useParams({
    from: "/$leaid/_error-wrapper/records/child/$entityid",
  });

  const leaData = useLeaData(params.leaid as string)?.data;

  const chldRecords =
    leaData?.entities?.children?.[params.entityid]?.records?.map((record) => {
      return {
        ...record,
        PreschoolName: leaContext?.currentOrgPreschools?.find(
          (x) => x.PreschoolCDSCode === record.PreschoolCode
        )?.PreschoolName,
      };
    }) ?? [];

  chldRecords.sort((x, y) => y.ProgramYear.localeCompare(x.ProgramYear));

  const child = chldRecords[0];

  if (!child) {
    throw new Error(`No child records exist for this CSPPID`);
  }

  const model = childHeadingModel({
    child: {
      ChildFirstName: child.ChildFirstName,
      ChildLastName: child.ChildLastName,
      LocalChildId: child.LocalChildId,
      PreschoolCode: child.PreschoolCode,
      CSPPID: child.CSPPID,
    },
    leaid: params.leaid as string,
    preschools: leaContext?.currentOrgPreschools ?? [],
  });

  return (
    <div className="d-flex flex-column gap-2 w-100">
      <div
        className="card mb-0 border-0 rounded-4 w-100"
        style={{ boxShadow: "none" }}
      >
        <div className="card-body px-3 py-3">
          <div className="row align-items-center">
            {/* Left side */}
            <div className="col-md-6 d-flex align-items-center gap-3">
              <div
                className="d-flex justify-content-center align-items-center rounded-4 text-white card-custom"
                style={{
                  width: "64px",
                  height: "64px",
                  background:
                    "linear-gradient(135deg, #003a5d 0%, #00527e 100%)",
                  fontWeight: 600,
                  fontSize: "1.5rem",
                }}
              >
                {(model.initials || "?").toUpperCase()}
              </div>

              <div>
                <div className="d-flex align-items-center gap-2 mb-1">
                  <span
                    className="fw-bold text-uppercase"
                    style={{
                      fontSize: "0.9rem",
                      lineHeight: 1,
                      letterSpacing: ".5px",
                    }}
                  >
                    Child Record
                  </span>
                </div>

                <h1 className="fw-bold mb-0" style={{ fontSize: "1.6rem" }}>
                  {model.childName || "Unknown child"}
                </h1>
              </div>
            </div>

            {/* Right side */}
            <div
              className="col-md-6 text-md-end mt-3 mt-md-0"
              style={{ fontSize: "1.1rem", lineHeight: "1.5" }}
            >
              <div className="mb-1">
                <span className="fw-bold">School:</span> {model.school}
              </div>
              <div className="mb-1">
                <span className="fw-bold">CSPPID:</span> {model.csppid || "-"}
              </div>
              <div>
                <span className="fw-bold"> Local Child ID (CICN):</span>{" "}
                {model.localId || "-"}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
